import React from 'react'
import PropTypes from 'prop-types'
import { Button, color, ContentDialog, device, space } from '@ticketswap/solar'
import ListItem from './ListItem'
import styled from '@emotion/styled'
import { eventListFragmentPropTypes } from '~/graphql/fragments/eventList'

const StyledList = styled.ul`
  margin: -${space[16]};

  @media ${device.tablet} {
    margin: -${space[24]};
  }
`

const ListButtonItem = styled.li`
  padding: ${space[16]};
  border-top: 1px solid ${color.spaceLightest};
`

const ListCardDialog = ({
  t,
  showDialog,
  items,
  hasNextPage,
  onShowMore,
  title,
  text,
  backgroundImage,
  logoUrl,
  onDismiss,
}) => {
  return (
    <ContentDialog
      isOpen={showDialog}
      title={title}
      subtitle={text}
      imageUrl={backgroundImage}
      logoUrl={logoUrl}
      onDismiss={onDismiss}
    >
      <StyledList>
        {items.map(({ node }) => {
          if (!node) return null
          return <ListItem key={node.id} t={t} event={node} />
        })}

        {hasNextPage && (
          <ListButtonItem>
            <Button size="small" width="full" onClick={onShowMore}>
              {t('common:generic.showMore')}
            </Button>
          </ListButtonItem>
        )}
      </StyledList>
    </ContentDialog>
  )
}

ListCardDialog.propTypes = {
  showDialog: PropTypes.bool.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      node: eventListFragmentPropTypes,
    })
  ).isRequired,
  hasNextPage: PropTypes.bool.isRequired,
  onShowMore: PropTypes.func,
  title: PropTypes.string.isRequired,
  text: PropTypes.string,
  backgroundImage: PropTypes.string.isRequired,
  logoUrl: PropTypes.string,
  onDismiss: PropTypes.func.isRequired,
}

export default ListCardDialog
